var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heatmap-container"},[_c('div',{ref:"heatmapChart",staticClass:"heatmap-chart"}),_c('div',{staticClass:"heatmap-description"},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v("  "),_c('span',[_vm._v(" 각 셀의 값은 평균 사용량을 나타냅니다. "+_vm._s(_vm.selectedPeriod === "yearly" ? "연간 에너지 사용 패턴은 여름철 부하 시간대를 기준으로 분석됩니다." : "")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }